var _defs, _path, _g, _text, _path2, _line, _path3, _path4, _line2, _line3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProsmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #5ccbf5;\n      }\n\n      .cls-4 {\n        stroke: #fff;\n      }\n\n      .cls-4, .cls-5 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        font-family: Gotham-Bold, Gotham;\n        font-size: 49.16px;\n        font-weight: 700;\n        letter-spacing: .05em;\n      }\n\n      .cls-6, .cls-2 {\n        fill: #351049;\n      }\n\n      .cls-5 {\n        stroke: #351049;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.19,212.06c-1.1-73.29-60.85-132.38-134.4-132.38s-133.98,59.74-134.42,133.61c0,.17.06.31.15.45,1.1,73.29,60.85,132.38,134.4,132.38s133.98-59.74,134.43-133.61c0-.17-.06-.32-.15-.45Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.78,303.09h-61.87s-61.87,0-61.87,0c-3.65,0-6.61-2.96-6.61-6.61h0c0-3.65,2.96-6.61,6.61-6.61h61.87s61.87,0,61.87,0c3.65,0,6.61,2.96,6.61,6.61h0c0,3.65-2.96,6.61-6.61,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.6,324.63h-45.27s-45.27,0-45.27,0c-3.65,0-6.61-2.96-6.61-6.61h0c0-3.65,2.96-6.61,6.61-6.61h45.27s45.27,0,45.27,0c3.65,0,6.61,2.96,6.61,6.61h0c0,3.65-2.96,6.61-6.61,6.61Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(120.68 409.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRISM AI"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.48,97.38l-100.97,157.94c-1.18,1.85-.07,4.31,2.1,4.64l101.19,15.45,101.42-15.49c2.06-.32,3.12-2.65,2-4.41l-101.09-158.14c-1.08-1.7-3.56-1.7-4.64,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 243.8,
    y1: 98.35,
    x2: 243.8,
    y2: 273.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.22,98.95l-100.42,157.09c-.32.5-.02,1.17.57,1.26l100.08,15.93c.24.04.48.04.71,0l100.06-15.93c.59-.09.9-.77.57-1.27l-100.41-157.08c-.27-.42-.89-.42-1.16,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.93,235.33l-100.31,21.8c-.08.04-.06.16.03.17l100.24,16.06,100.22-16.05c.1-.02.12-.15.03-.19l-100.2-21.79Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 243.81,
    y1: 98.35,
    x2: 224.58,
    y2: 270.19
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 243.8,
    y1: 98.35,
    x2: 263.03,
    y2: 270.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.62,257.19c-.08.04-.06.16.03.17l100.24,16.06,100.22-16.05c.1-.02.12-.15.03-.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsmLogo);
export default __webpack_public_path__ + "static/media/prosm-logo.e45bd51e580aa8cbf9425a941cac580f.svg";
export { ForwardRef as ReactComponent };